/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-06-21 18:09:25
 */
import { errorIfDevelopment } from "../configs/env";
import store from "../store";
import Vue from "vue";
import { uuid } from "../utils/uuid";

/**
 * Vue can only use string as key,
 * so map is needed.
 */
const FUNC_KEY_MAP = new Map();

/**
 * Use a vue object to restore cached key and value.
 */
const CACHE_POOL = new Vue({ data: {} });

class Field {
  constructor(func) {
    this._func = func;
    this._value = null;
    this._getter = null;
    this._version = 0;
  }

  _startToFetch() {
    this._version++;
    const version = this._version;
    const res = this._func();
    if (res instanceof Promise) {
      this._getter = res;
      res
        .then((r) => {
          if (version !== this._version) return;
          this._value = r;
        })
        .catch((err) => {
          if (version !== this._version) return;
          errorIfDevelopment("#-# Failed to fetch Cache Field:", err);
          this._value = null;
          this._getter = null;
        });
    } else {
      this._value = res;
    }
  }

  _getValue() {
    if (!!this._value) return Promise.resolve(this._value);
    else if (this._getter) return this._getter;
    else {
      this._startToFetch();
      return this._getValue();
    }
  }

  reset() {
    this._version++;
    this._value = null;
    this._getter = null;
  }

  get() {
    return this._getValue();
  }
}

const CACHE_PROXY_LIST = [];

/**
 *
 * @param {Function} func
 */
function cacheProxy(func) {
  if (!(func instanceof Function)) {
    throw new Error("Func must be null.");
  }

  const field = new Field(func);
  CACHE_PROXY_LIST.push(field);
  return {
    get() {
      return field.get();
    },
    reset() {
      return field.reset();
    },
  };
}

function cacheItem(key, value) {
  CACHE_POOL.$set(key, value);
  return {
    get() {
      return CACHE_POOL[key];
    },
    watch(cb) {
      return CACHE_POOL.$watch((s) => s[key], cb);
    },
  };
}

function clearCacheItem(key) {
  CACHE_POOL.$delete(key);
}

store.watch(
  (state) => state.userInfo.state,
  (newVal, oldVal) => {
    if (!!oldVal && !newVal) {
      CACHE_PROXY_LIST.forEach((p) => p.reset());
    }
  }
);

export { cacheProxy, cacheItem, clearCacheItem };
